module.exports = __webpack_public_path__ + "static/media/Flaticon2.eafcbac0.ttf";